import React, { Component } from "react";
import { reactLocalStorage } from 'reactjs-localstorage';
import { LOGIN_ROUTE } from "./helper/Constants";

class AuthChk extends Component {
    componentDidMount() {
        var url = window.location.href;
        var arr = url.split("/");
        //console.log('arr',arr);
        var base = ""
        if(arr[3]==""){
            base = "admin";
        }else{
            base = arr[3];
        }
        const token = reactLocalStorage.get("authToken");
        const tokenExpireDate = reactLocalStorage.get("expires_at");
        if (token != "" && token != undefined && token != null) {
            const now = new Date().valueOf();
            if (now >= tokenExpireDate) {
                reactLocalStorage.clear();
                url = arr[0] + "//" + arr[2] + "/" + base + LOGIN_ROUTE;
                window.location.href = url;
            }
        } else {
            reactLocalStorage.clear();
            url = arr[0] + "//" + arr[2] + "/admin" + LOGIN_ROUTE;
            window.location.href = url;
        }
    }
    render() {
        return (
            <React.Fragment>
            </React.Fragment>
        )
    }
}

export default AuthChk;
